import React, { useState } from 'react';
import Filters from '../../../components/Filter';
import FilterInput from '../../../components/Filter/components/FilterInput';
import { translate } from '../../../services/translate';
import { DispatchParamList } from '../../../typings/Params';
import { NavigationProp, RouteProp, useNavigation } from '@react-navigation/native';
import ActingBodiesDropdown from '../OccurrenceTypes/ActingBodiesDropdown';
import { useAuth } from '../../../context/Auth';

interface Props {
    filters: DispatchParamList['UnitDisplacedReasons'];
    setFilters: React.Dispatch<React.SetStateAction<DispatchParamList['UnitDisplacedReasons']>>;
    textFilter: string;
    setTextFilter: (value: string) => void;
}

function Filter({ filters, setFilters, textFilter, setTextFilter }: Props) {
    const { user: authenticatedUser } = useAuth();
    const navigation = useNavigation<NavigationProp<RouteProp<DispatchParamList, 'UnitDisplacedReasons'>>>();
    const [actingBodyId, setActingBodyId] = useState<number>(filters.actingBodyId ?? 0);

    const handleCleanFilter = () => {
        setTextFilter('');
        setActingBodyId(0);
    };

    const handleFilter = () => {
        navigation.setParams({
            ...filters,
            page: 1,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });

        setFilters({
            ...filters,
            page: 0,
            textFilter: textFilter !== '' ? textFilter : undefined,
            actingBodyId: actingBodyId !== 0 ? actingBodyId : undefined,
        });
    };

    return (
        <Filters onCleanFilters={handleCleanFilter} onFilters={handleFilter}>
            <FilterInput
                label={translate('searchUnitDisplacedReason')}
                value={textFilter}
                placeholder={translate('typeToSearch')}
                onChange={setTextFilter}
            />
            {(authenticatedUser?.isAdmin || authenticatedUser?.permissions.dispatch_manage_all_acting_bodies_unit_displaced_reasons) &&
                <ActingBodiesDropdown includeAllOption={true} value={actingBodyId} setValue={setActingBodyId} zIndex={2} />
            }
        </Filters>
    );
}

export default Filter;
